import { Navigate, useParams } from 'react-router-dom';

export default function StationLocaleRedirect() {
  const { stationCode } = useParams();
  const storedLocale = localStorage.getItem('locale');
  const browserLocale = navigator.language.toLowerCase().startsWith('ar') ? 'ar' : 'en';
  const locale = storedLocale === 'ar' || storedLocale === 'en' ? storedLocale : browserLocale;

  return <Navigate to={`/${locale}/station/${encodeURIComponent(stationCode || '')}`} replace />;
}
